import axios from 'axios';


export const getPage = (pagina, ordenacao, filtro) => {
  const queryString = Object.keys(filtro).map((key) => `${key}=${filtro[key]}`).join('&');
  return axios.get(`/documento?page=${pagina}&sort=${ordenacao},desc&${queryString}`);
};

export const uploadStorage = (data) => axios.post('/documento/upload', data);
export const cadastrar = (data) => axios.post('/documento', data);
export const getTipos = () => axios.get('/documento/tipos');
export const renomear = (id, nome) => axios.put(`/documento/${id}/renomear?nome=${nome}`)
export const fixarEmReunicao = (id) => axios.put(`/documento/${id}/fixar-em-reuniao`);
export const favoritar = (id) => axios.put(`/documento/${id}/favoritar`);
export const desafixarDeReunicao = (id) => axios.put(`/documento/${id}/desafixar-em-reuniao`);
export const desfavoritar = (id) => axios.put(`/documento/${id}/desfavoritar`);
export const excluir = (id) => axios.delete(`/documento/${id}`);
export const getUltimosAcessados = () => axios.get('/documento/ultimos-acessados')
export const download = (id) => axios.get(`/documento/${id}/download`, {
  responseType: 'arraybuffer',
});

export const getSize = (tamanho) => {
  if (tamanho >= (1024 * 1024 * 1024)) {
    return `${parseInt(tamanho / (1024 * 1024 * 1024))}gb`;
  }
  if (tamanho >= (1024 * 1024)) {
    return `${parseInt(tamanho / (1024 * 1024))}mb`;
  }
  if (tamanho >= 1024) {
    return `${parseInt(tamanho / 1024)}kb`;
  }
  return `${tamanho}bytes`;
}

export const getLastDate = (data = new Date().getTime()) => {
  const dataHoje = new Date().getTime();
  const dataDocumento = data ? new Date(data).getTime() : dataHoje;
  const dias = dataHoje - dataDocumento;

  if (dias >= 1000 * 3600 * 24) {
    return ` há ${parseInt((dataHoje - dataDocumento) / (1000 * 3600 * 24))} dias`
  }
  return ' hoje';
};
